define(function (require) {
	const tpl = require('civicsViews/new_attachments/templates/t_lov_attachment_group_row.hbs');
	const AttachmentView = require('civicsViews/new_attachments/v_itv_attachment.js');
	const AddAttachmentView = require('civicsViews/new_attachments/upload_modal/v_cpv_add_attachments');
	const AttachmentDetailView = require('civicsViews/new_attachments/info_modal/v_itv_attachment_viewer');

	const IpsModel = require('civicsBase/ipsModel');
	const IpsModelCollection = require('civicsBase/ipsModelCollection');

	const Radio = require('backbone.radio');
	const AttachmentChannel = Radio.channel('addAttachmentChannel');

	return Marionette.CompositeView.extend({
		template: tpl,
		ui: {
			addButton: '.attachment-row-add',
			noAttachments: '.no-attachments',
		},
		events: {
			'click @ui.addButton': 'openUploadModal'
		},
		childEvents: {
			'attachments:delete': 'onDeleteAttachment',
			'details:clicked': 'onClickDetails'
		},
		className: 'attachment-group-row',
		childViewContainer: '.collection-region',
		childView: AttachmentView,
		childViewOptions: function (model, index) {

			var permissions = [];
			var documentType = null;
			var constraint = null;
			// if(model.get('nonConstraintAttachment')) {    //not in upload catalog
			//   permissions.list = true;

			//   //validate that documentUri value is not null or empty string before setting open permission to true
			//   if(model.get('documentUri') != null && !_.isEmpty(model.get('documentUri'))) {
			//     permissions.open = true;
			//   }

			//   documentType = model.get('documentType');
			// } else {

			constraint = this.getConstraint(model);
			if (constraint) {
				documentType = this.fetchDocumentType(constraint);
				permissions = this.getPermissionsFromConstraint(constraint);
			} else {
				if (model) {
					documentType = model.get('documentType');
					permissions.add = false;
					permissions.update = false;
					permissions.delete = false;
					permissions.open = false;
					permissions.list = true;
					if (documentType &&
						model.get('documentURI') &&
						model.get('documentURI').trim() != '')
						permissions.open = true;
				}
			}
			//}

			return {
				config: this.config,
				modalRegion: this.modalRegion,
				isReviewProcess: this.isReviewProcess,
				isAddProcess: this.isAddProcess,
				documentTypeCollection: this.documentTypeCollection,
				showDocumentType: this.isOptionalFileView,
				permissions: permissions,
				collection: this.collection,
				parentMoniker: this.parentMoniker,
				parentPrimaryKey: this.parentPrimaryKey,
				documentType: documentType,
				rawAttachments: this.rawAttachments,
				viewName: this.viewName,
			};
		},
		getConstraint: function (attachment) {
			var self = this;
			if (self.isOptionalFileView) {
				var constraint = null;
				self.availableConstraints.each(function (aConstraint) {
					if (aConstraint.get('name') == attachment.get('documentType').get('name')) {
						constraint = aConstraint;
					}
				});

				return constraint;
			} else {
				return self.model;
			}

		},
		getDocumentTypeCollectionFromConstraint: function (collection) {
			var self = this;
			var doctypeColl = new IpsModelCollection();
			if (self.isOptionalFileView) {
				self.availableConstraints.each(function (aConstraint) {
					doctypeColl.add(self.fetchDocumentType(aConstraint));
				});
			} else {
				doctypeColl.add(self.fetchDocumentType(self.model));
			}

			return doctypeColl;
		},
		fetchDocumentType: function (constraint) {

			var doctype = new IpsModel();
			if (constraint != null) {
				doctype.set('attributes', constraint.get('attributes'));
				doctype.set('description', constraint.get('description'));
				doctype.set('name', constraint.get('name'));
				doctype.set('permissions', constraint.get('permissions'));
			}

			return doctype;
		},
		getPermissionsFromConstraint: function (mod) {
			var permissions = mod.get('permissions');

			return permissions.toJSON();
		},
		openUploadModal: function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			e.stopPropagation();

			if (this.addAttachmentView) {
				this.addAttachmentView.destroy();
			}

			this.addAttachmentView = new AddAttachmentView({
				config: this.config,
				catalog: this.catalog,
				modalRegion: this.modalRegion,
				isAddProcess: this.isAddProcess,
				documentTypeCollection: this.documentTypeCollection,
				existingAttachmentCollection: this.collection,
				parentMoniker: this.parentMoniker,
				parentPrimaryKey: this.parentPrimaryKey,
				isOptionalFileView: this.isOptionalFileView,

			});
			this.modalRegion.show(this.addAttachmentView);
			this.modalRegion.showModal();
		},
		onDeleteAttachment: function (view, model) {
			var self = this;
			var toRemove = self.collection.get({ cid: view.model.cid });
			self.collection.remove(toRemove);
			self.triggerMethod('attachments:delete', model);
		},
		onClickDetails: function (view, model, file) {
			var self = this;
			var modelDocumentType = this.fetchDocumentType(this.getConstraint(model));
			self.modalView = new AttachmentDetailView({
				model: model,
				documentTypeCollection: self.documentTypeCollection,
				parentMoniker: self.parentMoniker,
				parentPrimaryKey: self.parentPrimaryKey,
				parentCollection: self.collection,
				isAddProcess: self.isAddProcess,
				documentType: self.isAddProcess ? modelDocumentType : model.get('documentType'),
				file: self.isAddProcess && file && file instanceof Blob ? file : null,
			});

			self.modalRegion.show(self.modalView);
			self.modalRegion.showModal();
		},
		initialize: function (options) {
			this.config = options.config;
			this.catalog = options.catalog;
			this.modalRegion = options.modalRegion;
			this.collection = options.attachments;
			this.rawAttachments = options.rawAttachments;
			// this.nonConstraintAttachments = options.nonConstraintAttachments;


			this.isOptionalFileView = options.isOptionalFileView;

			// if(this.isOptionalFileView && this.nonConstraintAttachments !=null) {
			//   this.nonConstraintAttachments.each(function(attach) {
			//     this.collection.add(attach);
			//   }.bind(this));
			// }

			this.isAddProcess = options.isAddProcess;
			this.isReviewProcess = options.isReviewProcess;
			this.globalCanAdd = options.globalCanAdd;
			this.parentMoniker = options.parentMoniker;
			this.parentPrimaryKey = options.parentPrimaryKey;
			this.availableConstraints = options.availableConstraints;
			this.statusCheckRequirements = options.statusCheckRequirements;
			this.usesStatusCheckRequirements = options.usesStatusCheckRequirements;
			this.documentTypeCollection = this.getDocumentTypeCollectionFromConstraint(this.model);
			this.viewName = options.viewName;

			this.isMobile = function () {
				var check = false;
				(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
				return check;
			}();


		},
		onRender: function () {
			if (!this.isReviewProcess || (this.collection.length > 0)) {
				this.ui.noAttachments.hide();
			}
		},
		onShow: function () { },
		isComplete: function() {
			var self = this;
			if(self.isAddProcess || !self.usesStatusCheckRequirements) {
				return self.model.get('minimumAttachmentsRequired') != null && self.collection.length >= self.model.get('minimumAttachmentsRequired');
			} else {
				return self.usesStatusCheckRequirements && !self.statusCheckRequirements.includes(self.model.get('name'));
			}
		},
		templateHelpers: function () {
			var self = this;
			var isComplete = self.isComplete();
			var vn = this.viewName != null ? this.viewName : '';
			return {
				showAddButton: !self.isOptionalFileView && !self.isReviewProcess && this.model.get('permissions').get('add'),
				showLabel: !self.isOptionalFileView,
				uploadButtonLabel: i18n.t('CIVICS.COMMON_ATTACHMENTS.ADD_ITEM', { 'item': this.model.get('name') }),
				showPendingIcon: !isComplete,
				showCompleteIcon: isComplete,
				anchor: self.isOptionalFileView ? null : vn + "constraintUpload" + this.model.get('name').replace(/\W/g, ''),
				instructionsToShow: (self.model.get('instructions') != null && !_.isEmpty(self.model.get('instructions'))) ? self.model.get('instructions') : (self.model.get('minimumAttachmentsRequired') > 1 ? i18n.t('CIVICS.COMMON_ATTACHMENTS.ATTACHMENTS_REQUIRED', { name: self.model.get('name') }) : i18n.t('CIVICS.COMMON_ATTACHMENTS.ATTACHMENT_REQUIRED', { name: self.model.get('name') }))
			};
		},

	});
});
